define('plugin/invoice/collection/InvoiceTaxCollection',['require','lib/collection/BaseCollection','plugin/invoice/model/InvoiceTaxModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var InvoiceTaxModel = require('plugin/invoice/model/InvoiceTaxModel');

    /**
     * Invoice tax collection
     *
     * @class InvoiceTaxModel
     */
    return BaseCollection.extend({

        model: InvoiceTaxModel

    });

});
